/** InsCoder WANG.J 2026-08-27 B + Back-to-top floating button logic **/
(function () {
  const sections = document.querySelectorAll('[data-back-to-top-section]');
  if (sections.length === 0) return;

  const showAfter = 200; // px of scroll before the button appears

  sections.forEach((section) => {
    if (section.dataset.initialized === 'true') return; // skip already-initialized sections
    const button = section.querySelector('[data-back-to-top-button]');
    if (!button) return;

    // Mark BEFORE registering listeners, so a re-executed script cannot attach
    // a second set of scroll/click handlers to the same section.
    section.dataset.initialized = 'true';

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const visible = window.scrollY > showAfter;
          section.classList.toggle('is-visible', visible);
          section.setAttribute('aria-hidden', visible ? 'false' : 'true');
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    button.addEventListener('click', (event) => {
      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });
})();
/** InsCoder WANG.J 2026-08-27 E + Back-to-top floating button logic **/
